export enum ActionType {
  'FAX' = 'FAX',
  'EMAIL' = 'EMAIL',
  'CREATE_TASK' = 'CREATE_TASK',
  'CUSTOM_API' = 'CUSTOM_API',
}
